import { CellState } from '../hooks/useGameLogic';

interface GameBoardProps {
  grid: CellState[][];
  puzzle: { size: number } | null;
  cellSize: number;
  clickMode: 'fill' | 'x';
  onToggleCell: (row: number, col: number) => void;
}

export function GameBoard({ grid, puzzle, cellSize, clickMode, onToggleCell }: GameBoardProps) {
  if (!puzzle) return null;

  return (
    <div className="flex justify-center overflow-x-auto mb-6">
      <div
        id="grid"
        className="grid gap-0.5 p-2 bg-slate-200 dark:bg-slate-800 border-2 border-slate-300 dark:border-slate-700 rounded-lg"
        style={{ gridTemplateColumns: `repeat(${puzzle.size}, ${cellSize}px)` }}
      >
        {grid.map((row: CellState[], y: number) =>
          row.map((cell: CellState, x: number) => (
            <button
              type="button"
              key={`${y}-${x}`}
              className={`cell border border-slate-300 dark:border-slate-600 cursor-pointer flex items-center justify-center text-base rounded-sm
                ${cell === 'filled' ? 'bg-ua-blue text-white' : ''}
                ${cell === 'marked' ? 'bg-red-100 dark:bg-red-900 text-red-600' : 'bg-white dark:bg-slate-800 hover:bg-slate-100 dark:hover:bg-slate-700'}`}
              style={{ width: cellSize, height: cellSize }}
              onClick={() => onToggleCell(y, x)}
              aria-label={`Cell ${y+1},${x+1} ${cell === 'filled' ? 'filled' : cell === 'marked' ? 'marked' : 'empty'}`}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  onToggleCell(y, x);
                }
              }}
            >
              {cell === 'marked' ? '✕' : ''}
            </button>
          ))
        )}
      </div>
    </div>
  );
}
